const ChecklistItem = ({ item, correct }) => {
  const isCheckItem = item.type === 'check';
  const isSubheading = item.type === 'subheading';

  const itemClass = [
    'checklist-item',
    isSubheading ? 'subheading' : '',
    correct === true ? 'correct' : '',
    correct === false ? 'incorrect' : ''
  ].join(' ');

  return (
    <li className={itemClass}>
      <div className="checklist-item-content">
        {isCheckItem ? (
          <>
            <strong>{item.check}</strong>
            <span className="condition">{item.condition}</span>
          </>
        ) : (
          <span>{item.text}</span>
        )}
      </div>
      {isCheckItem && (
        <span className="status-icon">
          {correct === true ? '✅' : correct === false ? '❌' : ''}
        </span>
      )}
    </li>
  );
};

export default ChecklistItem;